import axios from "axios";
import api from "../../lib/api/api";

// Action Types for Creating a Course
export const CREATE_COURSE_REQUEST = "CREATE_COURSE_REQUEST";
export const CREATE_COURSE_SUCCESS = "CREATE_COURSE_SUCCESS";
export const CREATE_COURSE_FAILURE = "CREATE_COURSE_FAILURE";
export const UPDATE_COURSE_SUCCESS = "UPDATE_COURSE_SUCCESS";
export const UPDATE_COURSE_FAILURE = "UPDATE_COURSE_FAILURE";
export const CLEAR_CREATE_COURSE_STATE = "CLEAR_CREATE_COURSE_STATE";

// Action Types for Fetching Created Courses
export const FETCH_CREATED_COURSES_REQUEST = "FETCH_CREATED_COURSES_REQUEST";
export const FETCH_CREATED_COURSES_SUCCESS = "FETCH_CREATED_COURSES_SUCCESS";
export const FETCH_CREATED_COURSES_FAILURE = "FETCH_CREATED_COURSES_FAILURE";

// Action to create a course
export const createCourse = (courseData) => async (dispatch) => {
  dispatch({ type: CREATE_COURSE_REQUEST });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/teachers/create`,
      courseData
    );
    const successMessage =
      response.data.message || "Course created successfully!";
    const course = response.data.course || {}; // Assuming backend returns the created course object
    dispatch({
      type: CREATE_COURSE_SUCCESS,
      payload: { message: successMessage, course },
    });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error creating course!";
    dispatch({
      type: CREATE_COURSE_FAILURE,
      payload: { message: errorMessage },
    });
  }
};

export const updateCourse = (courseId, updatedData) => async (dispatch) => {
  dispatch({ type: CREATE_COURSE_REQUEST });
  try {
    const response = await api.put(`/courses/update/${courseId}`, updatedData);
    const successMessage =
      response.data.message || "Course updated successfully!";
    const course = response.data.course || {};
    dispatch({
      type: UPDATE_COURSE_SUCCESS,
      payload: { message: successMessage, course },
    });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error updating course!";
    dispatch({
      type: UPDATE_COURSE_FAILURE,
      payload: { message: errorMessage },
    });
  }
};

// Action to fetch created courses for the teacher
export const fetchCreatedCourses = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_CREATED_COURSES_REQUEST });

  try {
    const response = await api.get(`/teachers/teacher/${userId}`);
    dispatch({ type: FETCH_CREATED_COURSES_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error fetching created courses!";
    dispatch({
      type: FETCH_CREATED_COURSES_FAILURE,
      payload: { message: errorMessage },
    });
  }
};

export const clearCreateCourseState = () => ({
  type: CLEAR_CREATE_COURSE_STATE,
});

